import { useMarket } from './provider';
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Field,
} from '@headlessui/react';
import type { CountrySelectorList } from './types';
import { SelectBoxArrowDownWhite, SelectBoxArrowUpWhite } from '../Icons/icons';
import React, { useState } from 'react';
import Image from 'next/image';
import { Title } from '../Typography';

const MarketSelect = () => {
  const { marketConfig, redirectToMarket, currentSelectedMarketConfig } = useMarket();
  const [selectedMarket, setSelectedMarket] = useState(currentSelectedMarketConfig);

  const renderCountryFlagImage = (config: CountrySelectorList) => {
    if (!config?.countryFlag?.asset?.[0]?.url) {
      return null;
    }

    return (
      <img
        alt={`Flag of ${config?.country}`}
        src={config.countryFlag.asset[0].url}
        className="size-4 mr-2"
      />
    );
  };

  const onSubmit = () => {
    if (selectedMarket) {
      redirectToMarket(selectedMarket.countryCode);
    }
  };

  return (
    <div>
      <Title tag="h3" type="xs" className="text-white md:mb-30 sm:mb-10">
        {marketConfig?.title}
      </Title>
      <form action={onSubmit} className="max-w-56">
        <Field>
          <Listbox name="market" value={selectedMarket} onChange={setSelectedMarket}>
            <Label className="text-white block uppercase leading-4.5 tracking-xl text-xs font-geomanist">
              {marketConfig.countryLabel}
            </Label>
            <div className="relative mt-2">
              <ListboxButton className="grid grid-cols-1 w-full cursor-default rounded-2xl py-2 px-3 text-left text-white bg-[#010e54] border outline-none max-w-80 font-geomanist tracking-wider text-sm">
                {({ value, open }) => (
                  <>
                    <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                      {renderCountryFlagImage(value)}
                      <span className="block truncate">{value?.country}</span>
                    </span>
                    <span
                      aria-hidden="true"
                      className="col-start-1 row-start-1 self-center justify-self-end"
                    >
                      {open ? <SelectBoxArrowUpWhite /> : <SelectBoxArrowDownWhite />}
                    </span>
                  </>
                )}
              </ListboxButton>
              <ListboxOptions className="absolute max-h-56 z-10 mt-2 w-full overflow-auto rounded-md bg-[#010e54] py-2 ring-white divide-y border ring-1 focus:outline-none text-sm">
                {marketConfig?.countrySelectorList?.map((country) => (
                  <ListboxOption
                    key={country.id}
                    value={country}
                    className="group relative cursor-default select-none py-2 pl-3 pr-9 text-white hover:bg-white hover:text-black data-[selected]:bg-white data-[selected]:text-black font-geomanist tracking-wider"
                  >
                    <div className="flex items-center">
                      {renderCountryFlagImage(country)}
                      <span className="group-data-selected:font-semibold">{country?.country}</span>
                    </div>
                  </ListboxOption>
                ))}
              </ListboxOptions>
            </div>
          </Listbox>
        </Field>
        <button
          type="submit"
          className="text-white border-white border rounded-3xl px-8 md:py-4 sm:py-5 md:mt-5 sm:mt-10 font-geomanist text-xs leading-4 uppercase tracking-xl lg:text-sm ls:leading-4.5"
        >
          {marketConfig.textOnButton}
        </button>
      </form>
    </div>
  );
};

export default MarketSelect;
